import { useLayoutEffect, useRef, type RefObject } from 'react'

/** Store a value in a ref and keep it in sync when it changes */
export const useSyncedRef = <T>(value: T): RefObject<T> => {
  const syncedRef = useRef<T>(value)

  useLayoutEffect(() => {
    syncedRef.current = value
  }, [value])

  return syncedRef
}
